import { MenuItem, Select, useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';
import FieldFormControl from '../FieldFormControl';

const OptionSelectField = ({ field, minimal, disabled, labelStyle }) => {
	const theme = useTheme();
	const { setFieldValue, values, getFieldMeta, getFieldHelpers, getFieldProps } =
		useFormikContext();
	const { onBlur: onFieldBlur, ...fieldProps } = getFieldProps(field.name);
	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const options = field.field.options.slice().sort((a, b) => a.order - b.order);
	const value = values[field.name] ?? '';
	const currentValue = options.find((v) => v.value === value)?.value ?? '';

	const minimalInputTheme = theme.components.MuiInputBase.styleOverrides.minimal;

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	return (
		<>
			<FieldFormControl {...{ field, disabled, label: field.label, labelStyle }}>
				<Select
					id={field.name}
					className={minimal && 'minimal-input'}
					{...fieldProps}
					value={currentValue}
					disabled={disabled}
					onBlur={onBlur}
					error={error}
					onChange={(e) => setFieldValue(field.name, e.target.value)}
					displayEmpty
					fullWidth
					variant={minimal ? 'standard' : 'outlined'}
					sx={{
						...(minimal && {
							...minimalInputTheme,
							'& .Mui-disabled': {
								backgroundColor: 'transparent',
							},
						}),
					}}
				>
					{options.map((option) => (
						<MenuItem value={option.value} key={`state-${option.label}`}>
							{option.label}
						</MenuItem>
					))}
				</Select>
			</FieldFormControl>
		</>
	);
};

export default OptionSelectField;
